import * as querystring from 'querystring';
import * as _ from 'lodash';

const defaultOrigin = () => window && window.location.origin;

export function generateV1SavedViewUrl(savedView, entity, origin = defaultOrigin()) {
  const viewState = savedView.view_state;
  const fiscalYearRange = viewState.fiscal_year_range;
  let params = '';

  if (viewState.query) {
    // Grid Report saved views
    params = querystring.stringify({
      query: viewState.query
    });
  } else {
    // Other Saved Views
    params = querystring.stringify({
      breakdown: viewState.breakdown_id,
      accountType: viewState.ledger,
      graph: viewState.graph,
      month: viewState.month || 'latest',
      year: viewState.year || 'latest',
      selection: viewState.selection,
      legend_sort: viewState.sort_order,
      saved_view: viewState.id,
      projections: viewState.projections === true,
      projectionType: viewState.projection_type,
      highlightingVariance: viewState.highlighting_variance,
      highlighting: viewState.highlighting === true,
      fiscal_start: _.result(fiscalYearRange, 'start'),
      fiscal_end: _.result(fiscalYearRange, 'end'),
      currentYearPeriod: viewState.current_year_period,
      currentYearAmount: viewState.current_year_amount,
      selectedDataSetIndex: viewState.selected_data_set_index
    });
  }

  const path = `/reports#/${entity.id}/${savedView.report_id}/${params}`;

  return `${origin}${path}`;
}

export const generateV2SavedViewUrl = (
  entitySubdomain: string,
  reportConfigurationId: string,
  reportId: string,
  savedViewId: string
) => `/reporting/${entitySubdomain}/${reportId}/${reportConfigurationId}?savedViewId=${savedViewId}`;
